import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.project.deploy.edit');
import { OnInit, Input, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-project-deploy-edit',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/portal.infra.project.deploy.edit/view.scss */
/* src/app/portal.infra.project.deploy.edit/view.scss: no such file or directory */`],
})
export class PortalInfraProjectDeployEditComponent implements OnInit {
    @Input() model: any = null;
    @Input() project: any = {};

    public deploy_name: any = "";

    public selected: any;
    public hosts: any = [];
    public ips: any = [];
    public deploy: any = [];
    public ip_usage: any = {};
    public ipDropdownStyle: any = {};

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private eRef: ElementRef) { }

    private _docClickBound: any = null;

    public async ngOnInit() {
        await this.service.init();
        this._docClickBound = this._onDocumentClick.bind(this);
        document.addEventListener('click', this._docClickBound, true);
        await this.load();
    }

    ngOnDestroy() {
        if (this._docClickBound) {
            document.removeEventListener('click', this._docClickBound, true);
        }
    }

    private _onDocumentClick(event: MouseEvent) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.closeAllIpDropdowns();
        }
    }

    public async load() {
        this.deploy_name = this.model.deploy.name;

        const { data } = await wiz.call("info", { id: this.project.id, deploy_id: this.model.deploy.deploy_id });

        this.hosts = data.hosts;
        this.ips = data.ips;
        this.deploy = data.deploy;
        this.ip_usage = data.ip_usage || {};
        this.selected = data.ref;

        let orgparams = this.model.deploy.params;

        // Build host lookup map from project hosts: "host" → true
        let hostMap = {};
        for (let h of this.hosts) {
            hostMap[this.hostName(h)] = true;
        }

        for (let i = 0; i < this.selected.params.length; i++) {
            let param = this.selected.params[i];

            if (orgparams[param.name]) {
                if (param.type == 'hostname') {
                    let ovalue = orgparams[param.name];
                    param.value_basehost = '';
                    param.value_name = '';

                    // Match hostname against project hosts to find base host and subdomain
                    for (let hostKey in hostMap) {
                        if (ovalue === hostKey) {
                            // Exact match: hostname is the base host (no subdomain)
                            param.value_basehost = hostKey;
                            param.value_name = '';
                            break;
                        } else if (ovalue.endsWith('.' + hostKey)) {
                            // Subdomain match: extract subdomain prefix
                            param.value_basehost = hostKey;
                            param.value_name = ovalue.slice(0, ovalue.length - hostKey.length - 1);
                            break;
                        }
                    }
                } else {
                    param.value = orgparams[param.name];
                }
            } else {
                if (param.type == 'hostname') {
                    param.value_basehost = '';
                } else if (param.type == 'list') {
                    let desc = param.description || '';
                    let options = desc.split(',').map((s: string) => s.trim()).filter((s: string) => s);
                    param.value = options.length > 0 ? options[0] : '';
                } else {
                    param.value = "";
                }
            }

            if (param.type === 'ip') {
                param._showDropdown = false;
                param._searchText = "";
            }
        }
        await this.service.render();
    }

    public toggleIpDropdown(item: any, event?: MouseEvent) {
        const wasOpen = item._showDropdown;
        this.closeAllIpDropdowns();
        item._showDropdown = !wasOpen;
        if (item._showDropdown) {
            item._searchText = "";
            if (event) {
                const trigger = (event.currentTarget as HTMLElement);
                const rect = trigger.getBoundingClientRect();
                const dropdownMaxH = 240;
                const spaceBelow = window.innerHeight - rect.bottom;
                const openUpward = spaceBelow < dropdownMaxH && rect.top > dropdownMaxH;
                this.ipDropdownStyle = {
                    position: 'fixed',
                    left: rect.left + 'px',
                    width: rect.width + 'px',
                    'z-index': '99999'
                };
                if (openUpward) {
                    this.ipDropdownStyle['bottom'] = (window.innerHeight - rect.top + 4) + 'px';
                } else {
                    this.ipDropdownStyle['top'] = (rect.bottom + 4) + 'px';
                }
            }
        }
        this.service.render();
    }

    public closeAllIpDropdowns() {
        if (this.selected && this.selected.params) {
            for (let p of this.selected.params) {
                if (p.type === 'ip') p._showDropdown = false;
            }
        }
    }

    public selectIp(item: any, ip: string) {
        item.value = ip;
        item._showDropdown = false;
        this.service.render();
    }

    public getFilteredIps(item: any) {
        const text = (item._searchText || '').toLowerCase();
        if (!text) return this.ips;
        return this.ips.filter((ip: any) => {
            const ipStr = (ip.ip || '').toLowerCase();
            const usedBy = (this.ip_usage[ip.ip] || '').toLowerCase();
            return ipStr.includes(text) || usedBy.includes(text);
        });
    }

    public hostName(host: any): string {
        if (!host) return '';
        if (host.host) return host.host;
        const name = (host.name || '').trim();
        const basehost = (host.basehost || '').trim();
        return name ? `${name}.${basehost}` : basehost;
    }

    public async update() {
        if (!this.deploy_name)
            return await this.service.modal.error(`Input Deploy Name`, false, `Confirm`);

        await this.service.status.show("loading");
        let params = {};

        for (let i = 0; i < this.selected.params.length; i++) {
            let param = this.selected.params[i];
            if (param.type == 'hostname') {
                let value = param.value_basehost;
                if (param.value_basehost) {
                    const subdomain = (param.value_name || '').trim();
                    if (subdomain && subdomain !== '@')
                        value = subdomain + "." + value;
                }
                params[param.name] = value;
            } else if (param.type == 'namespace') {
                params[param.name] = this.project.id;
            } else {
                params[param.name] = param.value ? param.value : '';
            }
        }

        let pd = JSON.parse(JSON.stringify(this.model.deploy));
        pd.params = params;
        pd.name = this.deploy_name;

        const { code, data } = await wiz.call("update", { data: JSON.stringify(pd) });
        await this.service.status.hide("loading");
        if (code != 200) {
            return await this.service.modal.error(data, false, `Confirm`);
        }
        await this.model.action();
    }

}

export default PortalInfraProjectDeployEditComponent;